import { useEffect, useState } from "react";
import { appConfig } from "../app-config";
import { Button, Typography } from "@mui/material";
import * as formatters from '../utils/util';
import langDetails from '../components/MultiLanguage/language.json';

const RemainFunds = ({ handleNext, sharedData, updateSharedData }) => {
    const lang = langDetails[sharedData?.language];
    const onCreateAccount = () => {
        // if ((sharedData?.paymentMethodID && sharedData?.paymentMethodID !== "") || (sharedData?.donationAmount?.youGive > 0) ) {
        //     //Selected Value  Fund
        //     // sessionStorage.setItem("tabInfo", "switchToTab1");
        //     window.parent.postMessage("switchToTab1", "*");
        // } else  {
            //Selected Value  PIN
            sessionStorage.setItem("giveCardDatas", JSON.stringify(sharedData?.applyCardData));
            sessionStorage.removeItem("sharedData");
            window.parent.postMessage("switchToTab0", "*");
        // }
        
    }
    return (
        <div>
            <div className="mb-30 " >
            <div  className='flex-space-btw' >
                <Typography className="query-head">
                {lang?.YouStillHaveFunds}
                </Typography>
                {/* <Typography className="sub-head-1">
                {sharedData?.donationAmount?.currencySymbol}{(sharedData?.donationAmount?.totalAmount - sharedData?.donationAmount?.youGive).toString().includes(".") ? (sharedData?.donationAmount?.totalAmount - sharedData?.donationAmount?.youGive) : (sharedData?.donationAmount?.totalAmount - sharedData?.donationAmount?.youGive)+".00" } {lang?.balance}
                </Typography> */}
            </div>
            <div className="mt-30 flex-center">
                <Typography className="lg-normal-text-1">
               {lang?.AccountToSaveYourBalance}
                </Typography>
            </div>
            <div className="mt-30">
            <Button sx={{textTransform:'none !important'}} className="normal-text next-btn" variant='contained'
        onClick={onCreateAccount}
      >
        {lang?.CreateAnAccount}
      </Button>
            </div>
            <div className="mt-30 flex-center">
               <a href="#" style={{color:'black'}} onClick={()=>{
                // if (sharedData?.donationAmount?.youGive > 0 ) {
                //     handleNext(1)
                // } else  {
                    sessionStorage.removeItem("giveCardDatas");
                    handleNext(0);
                // }
                }}> <Typography className="lg-btn-text">{lang?.ContinueWithoutAnAccount}</Typography></a>
            </div>
            </div>
        </div>
    );
}

export default RemainFunds;